import { Reveal, Label } from "@/components/motion";

const steps = [
  { n: "01", title: "Discover", text: "Tell us what inspires you." },
  { n: "02", title: "Curate", text: "We shape the journey around your preferences." },
  { n: "03", title: "Experience", text: "Travel with confidence and enjoy the journey." },
];

export default function Approach() {
  return (
    <section data-testid="home-approach" className="border-t border-mist bg-white">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Reveal>
              <Label>The Urban Trail Approach</Label>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 max-w-lg font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                We plan the journey around you.
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-10 max-w-md text-lg leading-relaxed text-graphite">
                No two travellers experience a destination in quite the same way.
                That's why we begin with you — your interests, your pace, your
                expectations — and shape the journey from there.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <div data-testid={`approach-step-${s.n}`} className="flex gap-8 border-t border-mist py-10 last:border-b">
                  <span className="font-serif text-3xl font-light text-gold">{s.n}</span>
                  <div>
                    <h3 className="text-[13px] font-medium uppercase tracking-[0.28em] text-ink">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-steel">{s.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
